import axios from "../utils/axiosConfig";
import { apiConfig } from "../config/api.config";

const getAuthToken = () => {
  return document.cookie
    .split(";")
    .find((row) => row.trim().startsWith("auth_token="))
    ?.split("=")[1];
};

export const valveService = {
  // 获取阀门列表
  getValveList: async (params) => {
    const response = await axios.get(
      `${apiConfig.getFullURL("/ark/valve/list")}`,
      {
        params: {
          ...params,
          auth_token: getAuthToken(),
        },
      }
    );
    return response.data;
  },

  // 获取阀门详情
  getValveDetail: async (id) => {
    const response = await axios.get(
      `${apiConfig.getFullURL(`/ark/valve/${id}`)}`,
      {
        params: { auth_token: getAuthToken() },
      }
    );
    return response.data;
  },

  // 删除阀门
  removeValve: async (valveId) => {
    const response = await axios.post(
      `${apiConfig.getFullURL("/ark/valve/remove")}`,
      {
        valve_id: valveId,
        auth_token: getAuthToken(),
      }
    );
    return response.data;
  },

  // 批量更新阀门状态
  batchUpdateStatus: async (ids, status) => {
    const response = await axios.post(
      `${apiConfig.getFullURL("/ark/valve/batch_update_status")}`,
      {
        ids,
        status,
        auth_token: getAuthToken(),
      }
    );
    return response.data;
  },

  // 创建阀门
  createValve: async (valveData) => {
    const response = await axios.post(
      `${apiConfig.getFullURL("/ark/valve/create")}`,
      {
        ...valveData,
        auth_token: getAuthToken(),
      }
    );
    return response.data;
  },

  // 更新阀门
  updateValve: async (valveData) => {
    const response = await axios.post(
      `${apiConfig.getFullURL("/ark/valve/update")}`,
      {
        ...valveData,
        auth_token: getAuthToken(),
      }
    );
    return response.data;
  },

  // 创建工单
  createTicket: async (valveId, creatorId, assignId, gisPic, locationPic) => {
    const response = await axios.post(
      `${apiConfig.getFullURL("/ark/ticket/create")}`,
      {
        valve_id: valveId,
        creator_id: creatorId,
        assign_id: assignId,
        gis_pic: gisPic,
        location_pic: locationPic,
        auth_token: getAuthToken(),
      }
    );
    return response.data;
  },

  // 撤销工单
  revokeTicket: async (valveId) => {
    const response = await axios.post(
      `${apiConfig.getFullURL("/ark/ticket/revoke")}`,
      {
        valve_id: valveId,
        auth_token: getAuthToken(),
      }
    );
    return response.data;
  },

  // 获取信息卡（直接下载文件）
  getInfoCard: async (data) => {
    const response = await axios.post(
      `${apiConfig.getFullURL("/ark/valve/info_card")}`,
      {
        ...data,
        auth_token: getAuthToken(),
      },
      {
        responseType: 'blob',
      }
    );
    const disposition = response.headers?.['content-disposition'];
    let filename = 'info_card.docx';
    if (disposition && disposition.indexOf('filename=') !== -1) {
      filename = decodeURIComponent(disposition.split('filename=')[1].replace(/['"]/g, ''));
    }
    
    // 返回数据和文件名，而不是直接下载
    return {
      data: response.data,
      filename: filename
    };
  },
};
